// @ts-nocheck
import { useEffect, useState } from 'react';

import { Text, YStack } from 'tamagui';

import { Header, Footer } from '../components/landing';

const SECTIONS = [
  {
    title: 'What we collect',
    content: `When you create an account, we collect your email address and basic profile information. When you connect third-party apps (Gmail, Slack, Notion, etc.), we store the OAuth tokens necessary to access those services on your behalf. We also collect usage data such as search queries, feature usage, and performance metrics to improve the product.`,
  },
  {
    title: 'How we use it',
    content: `We use your data to provide and improve the Torch service. Specifically, we use OAuth tokens to index and search your connected apps, usage data to improve search ranking and relevance, and your email address to send product updates and important service notifications. We do not use your data to train machine learning models.`,
  },
  {
    title: 'What we don\'t do',
    content: `We do not sell your personal data to anyone. We do not share your data with third parties except for essential service providers (hosting, payment processing). We do not read your emails, messages, or documents for advertising purposes. We do not retain data from connected apps after you disconnect them.`,
  },
  {
    title: 'Data storage',
    content: `All data is encrypted at rest and in transit using industry-standard encryption (AES-256 at rest, TLS 1.3 in transit). Our infrastructure is hosted on US-based servers via Google Cloud Platform. We maintain regular backups and follow security best practices for access control and monitoring.`,
  },
  {
    title: 'OAuth scopes',
    content: `When you connect a third-party app, we request the minimum necessary permissions to provide search and indexing functionality. Where possible, we use read-only scopes. You can review the exact permissions requested during the OAuth flow for each integration. You can revoke access to any connected app at any time from your account settings.`,
  },
  {
    title: 'Data retention',
    content: `We retain your account data and indexed content for as long as your account is active. When you disconnect an app, we delete the associated indexed data within 30 days. You can delete your entire account and all associated data at any time from your account settings. Upon account deletion, all data is permanently removed within 30 days.`,
  },
  {
    title: 'Cookies',
    content: `We use essential cookies for authentication and session management. We do not use third-party advertising or tracking cookies. Analytics cookies are used only to understand aggregate usage patterns and can be disabled in your browser settings.`,
  },
  {
    title: 'Changes to this policy',
    content: `We may update this privacy policy from time to time. We will notify you of any material changes via email or a prominent notice within the product. Continued use of Torch after changes constitutes acceptance of the updated policy.`,
  },
  {
    title: 'Contact',
    content: `If you have questions about this privacy policy or your data, contact us at dans@romans.dev.`,
  },
];

export default function PrivacyPage() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <YStack backgroundColor="$background" minHeight="100vh">
      <Header />

      <YStack paddingTop={140} paddingHorizontal="$5" gap="$8" paddingBottom={80}>
        <YStack maxWidth={800} alignSelf="center" width="100%">
          {/* Page header */}
          <YStack marginBottom={48}>
            <Text
              fontSize={isMobile ? 30 : 44}
              fontWeight="700"
              letterSpacing={-1.5}
              lineHeight={isMobile ? 36 : 52}
              color="$color12"
            >
              Privacy Policy
            </Text>
            <Text fontSize={14} color="$color8" marginTop="$3">
              Effective date: March 2026
            </Text>
          </YStack>

          <Text fontSize={16} color="$color10" lineHeight={26} marginBottom={40}>
            Torch is built by SID Technologies. We take your privacy seriously. This policy explains
            what data we collect, how we use it, and what rights you have.
          </Text>

          {/* Sections */}
          <YStack gap="$6">
            {SECTIONS.map((section) => (
              <YStack key={section.title} gap="$2">
                <Text
                  fontSize={20}
                  fontWeight="600"
                  color="$color12"
                  letterSpacing={-0.3}
                >
                  {section.title}
                </Text>
                <Text fontSize={15} color="$color10" lineHeight={26}>
                  {section.content}
                </Text>
              </YStack>
            ))}
          </YStack>
        </YStack>
      </YStack>

      <Footer />
    </YStack>
  );
}
